// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__wsNpH","productName":"Table_productName__3s5mP"};